import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnIO: CultureInfo = {
  name: 'en-IO',
  displayName: 'English (British Indian Ocean Territory)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-IO',
  parent: CultureInfoEn
};
